import type { Bound, TransformedSegment } from '../../../../../../../widgets/trip-itinerary/models';

export const transformSegments = (segments: Bound['segments']): TransformedSegment[] => {
  return segments
    .map((segment, i, allSegments) => {
      if (segment.__typename === 'EventSegment') {
        const nextSegment = allSegments[i + 1];
        const previousSegment = allSegments[i - 1];

        if (
          nextSegment?.__typename === 'TripSegment' &&
          previousSegment?.__typename === 'TripSegment'
        ) {
          return {
            ...segment,
            nextAirport: nextSegment.origin.name,
            nextDeparture: nextSegment.departuredAt,
            previousArrival: previousSegment.arrivedAt,
            previousAirport: previousSegment.destination.name,
            previousDestination: previousSegment.destination.cityName,
          };
        }
      }

      if (segment.__typename === 'TripSegment') {
        return segment;
      }

      return null;
    })
    .filter((segment): segment is TransformedSegment => Boolean(segment?.__typename));
};
